import { useRequest } from "ahooks";
import { useState } from "react";
import MembershipDB from "./model/membership";

export default function useGetMemberByStudent({ studentId }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const res = useRequest(MembershipDB.getByStudent, {
    defaultParams: [{ studentId }],
    pollingInterval: 30000,
    cacheKey: `student-membership-${studentId}`,
    refreshDeps: [refreshKey],
  });

  // Somewhere to trigger refresh
  const manualRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return { manualRefresh, ...res };
}
